var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticStyle:{"text-align":"center"}},[(!_vm.hata)?_c('h3',[_vm._v("Bu anket tamamlandı veya henüz başlamadı.")]):_vm._e(),(_vm.hata)?_c('h3',[_vm._v(_vm._s(_vm.hata))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }